"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Filter',
    description: 'Filter records that go forward through the flow',
});
//# sourceMappingURL=filter.js.map